module.exports = __webpack_public_path__ + "img/team.4d595973.png";